import script from "./sf-flash-manager.vue?vue&type=script&lang=ts&setup=true"
export * from "./sf-flash-manager.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__